import { ReactNode, RefObject, useRef } from 'react';
import { useModal } from '@/components/modals/Modal';
import { getExportFileName } from '@/services/FileService';
import { ExportIcon } from '@/components/icons';
import { InnerHtml } from '../InnerHtml';
import { ImageCaptureButton } from './ImageCaptureButton';
import { useTranslation } from '@/hooks/useTranslation';

export function ExportableToImage({
  name,
  children,
}: {
  name: string;
  children: ReactNode;
}) {
  const exportableRef = useRef<HTMLDivElement>(null);
  return (
    <div className="relative">
      <ExportToImageButton
        refToExport={exportableRef}
        name={getExportFileName(name)}
      />
      <div ref={exportableRef} className="w-full">
        {children}
      </div>
    </div>
  );
}

function ExportToImageButton({
  refToExport,
  name,
}: {
  refToExport: RefObject<HTMLDivElement | null>;
  name: string;
}) {
  const modal = useModal();
  const { t } = useTranslation();

  return (
    <button
      className="tertiary bg-transparent small absolute top-0 right-0 z-40"
      onClick={() =>
        modal.openModal(
          <ExportToImageModal refToExport={refToExport} name={name} />,
          {
            title: t('components.generic.exportable_to_image.title'),
            widthClass: 'w-2/3 overflow-y-auto',
          },
        )
      }
    >
      <ExportIcon className="w-4 h-4" />
    </button>
  );
}

export function ExportToImageModal({
  refToExport,
  name,
}: {
  refToExport: RefObject<HTMLDivElement | null>;
  name: string;
}) {
  const myRef = useRef<HTMLDivElement>(null);

  return (
    <div className="flex flex-col gap-4">
      <div ref={myRef}>
        <InnerHtml
          html={refToExport?.current?.innerHTML || ''}
          className="p-4 rounded-xl m-auto block max-w-5xl w-full"
        />
      </div>

      <div className="flex justify-end">
        <ImageCaptureButton targetRef={myRef} downloadName={name} />
      </div>
    </div>
  );
}
